import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateModule } from '@ngx-translate/core';
import { TokenInterceptor } from '../../../../src/app/auth/token.interceptor';

import { commonDataService } from './service/commonUsage.data.service';
import { userUsageDataService } from './service/userUsage.data.service';
import { deviceUsageDataService } from './service/deviceUsage.data.service';
import { applicationUsageDataService } from './service/applicationUsage.data.service';
import { learningContentDataService } from './service/contentUsage.data.service';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    TranslateModule.forRoot(),
  ],
  providers: [
    commonDataService,
    userUsageDataService,
    deviceUsageDataService,
    applicationUsageDataService,
    learningContentDataService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
@NgModule({})
export class DashboardSharedModule{
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AppModule,
      providers: []
    };
  }
}